<template>
  <div class="app-container">
    <el-card class="search-card" shadow="never">
      <el-form :inline="true" :model="queryParams">
        <el-form-item label="数据类型">
          <el-select v-model="queryParams.dataType" placeholder="请选择" clearable>
            <el-option label="充电站" value="station" />
            <el-option label="充电设备" value="equipment" />
            <el-option label="充电口" value="port" />
            <el-option label="充电订单" value="order" />
            <el-option label="过程上报" value="report" />
            <el-option label="告警" value="alarm" />
          </el-select>
        </el-form-item>
        <el-form-item label="业务编号">
          <el-input v-model="queryParams.dataId" placeholder="请输入业务编号" clearable />
        </el-form-item>
        <el-form-item label="推送状态">
          <el-select v-model="queryParams.pushStatus" placeholder="请选择" clearable>
            <el-option label="成功" :value="1" />
            <el-option label="失败" :value="0" />
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" @click="handleQuery">搜索</el-button>
          <el-button icon="el-icon-refresh" @click="resetQuery">重置</el-button>
          <el-button type="info" plain icon="el-icon-question" @click="handleGuide">操作指引</el-button>
        </el-form-item>
      </el-form>
    </el-card>

    <el-card shadow="never">
      <el-table v-loading="loading" :data="pushLogList">
        <el-table-column label="序号" type="index" width="80" :index="getRowIndex" />
        <el-table-column label="数据类型" prop="dataType" width="120">
          <template slot-scope="scope">
            <el-tag size="mini">{{ getDataTypeLabel(scope.row.dataType) }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="业务编号" prop="dataId" width="180" />
        <el-table-column label="推送状态" align="center" width="100">
          <template slot-scope="scope">
            <el-tag :type="scope.row.pushStatus === 1 ? 'success' : 'danger'">
              {{ scope.row.pushStatus === 1 ? '成功' : '失败' }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column label="接口 URL" prop="interfaceUrl" show-overflow-tooltip />
        <el-table-column label="创建时间" prop="createdTime" width="180" />
        <el-table-column label="操作" align="center" width="150" fixed="right">
          <template slot-scope="scope">
            <el-button size="mini" type="text" @click="handleViewDetail(scope.row)">详情</el-button>
            <el-button size="mini" type="text" @click="handleRetry(scope.row)">重试</el-button>
          </template>
        </el-table-column>
      </el-table>

      <el-pagination
        v-show="total > 0"
        :current-page.sync="queryParams.pageNum"
        :page-size.sync="queryParams.pageSize"
        :page-sizes="[10, 20, 50, 100]"
        :total="total"
        background
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="getList"
        @current-change="getList"
      />
    </el-card>

    <el-dialog title="推送详情" :visible.sync="detailOpen" width="900px">
      <el-descriptions v-if="detail" :column="2" border>
        <el-descriptions-item label="日志 ID">{{ detail.id }}</el-descriptions-item>
        <el-descriptions-item label="数据类型">{{ getDataTypeLabel(detail.dataType) }}</el-descriptions-item>
        <el-descriptions-item label="业务编号">{{ detail.dataId }}</el-descriptions-item>
        <el-descriptions-item label="推送状态">{{ detail.pushStatus === 1 ? '成功' : '失败' }}</el-descriptions-item>
        <el-descriptions-item label="接口 URL" :span="2">{{ detail.interfaceUrl }}</el-descriptions-item>
        <el-descriptions-item label="错误信息" :span="2">{{ detail.errorMessage || '-' }}</el-descriptions-item>
        <el-descriptions-item label="创建时间" :span="2">{{ detail.createdTime }}</el-descriptions-item>
      </el-descriptions>
      <el-divider content-position="left">请求报文</el-divider>
      <pre class="log-block">{{ formatJson(detail && detail.requestBody) }}</pre>
      <el-divider content-position="left">响应报文</el-divider>
      <pre class="log-block">{{ formatJson(detail && detail.responseBody) }}</pre>
    </el-dialog>
  </div>
</template>

<script>
import { getPushLogDetail, listPushLog, retryPush } from '@/api/coo/push'

export default {
  name: 'PushLog',
  data() {
    return {
      loading: true,
      pushLogList: [],
      total: 0,
      detailOpen: false,
      detail: null,
      queryParams: {
        pageNum: 1,
        pageSize: 20,
        dataType: undefined,
        dataId: undefined,
        pushStatus: undefined
      }
    }
  },
  created() {
    this.getList()
    this.$guide.startGuideIfNeeded('push')
  },
  methods: {
    handleGuide() {
      this.$guide.startGuide('push')
    },
    getList() {
      this.loading = true
      listPushLog(this.queryParams).then(response => {
        this.pushLogList = response.data || []
        this.total = response.total || 0
        this.loading = false
      }).catch(() => {
        this.loading = false
      })
    },
    handleQuery() {
      this.queryParams.pageNum = 1
      this.getList()
    },
    resetQuery() {
      this.queryParams = {
        pageNum: 1,
        pageSize: 20,
        dataType: undefined,
        dataId: undefined,
        pushStatus: undefined
      }
      this.handleQuery()
    },
    getRowIndex(index) {
      return (this.queryParams.pageNum - 1) * this.queryParams.pageSize + index + 1
    },
    handleViewDetail(row) {
      getPushLogDetail(row.id).then(response => {
        if (response.code === 200) {
          this.detail = response.data
          this.detailOpen = true
        } else {
          this.$message.error(response.message || '获取详情失败')
        }
      })
    },
    handleRetry(row) {
      this.$confirm('确认重新推送这条记录吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => retryPush(row.id)).then(response => {
        if (response && response.code === 200) {
          this.$message.success(response.message || '重新推送成功')
          this.getList()
          if (this.detailOpen && this.detail && this.detail.id === row.id) {
            this.handleViewDetail(row)
          }
        } else if (response) {
          this.$message.error(response.message || '重新推送失败')
        }
      })
    },
    getDataTypeLabel(type) {
      const labelMap = {
        station: '充电站',
        equipment: '充电设备',
        port: '充电口',
        order: '充电订单',
        report: '过程上报',
        alarm: '告警'
      }
      return labelMap[type] || type || '-'
    },
    formatJson(value) {
      if (!value) return '-'
      if (typeof value !== 'string') {
        return JSON.stringify(value, null, 2)
      }
      try {
        return JSON.stringify(JSON.parse(value), null, 2)
      } catch (e) {
        return value
      }
    }
  }
}
</script>

<style scoped>
.search-card {
  margin-bottom: 15px;
}

.log-block {
  max-height: 260px;
  overflow: auto;
  padding: 12px;
  margin: 0;
  background: #f6f8fa;
  border-radius: 4px;
  white-space: pre-wrap;
  word-break: break-all;
}
</style>
